module.exports = __webpack_public_path__ + "assets/img/troy.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service-logos/troy.png
// module id = 78
// module chunks = 0